import { shoppingCartActionTypes } from '~/store/legacy/actions/shoppingCartActions.js';
import { userActionTypes } from '~/store/legacy/actions/userActions.js';
// TODO: think about moving session stuff somewhere else. reducers should technically not have side effects
import { setSessionItem, removeSessionItem } from '~/store/storage';

export const DEFAULT_PERCENTAGE_TIPS = [
  { key: '1st', type: 'cannedPercentage', value: '10', display: '10%' },
  { key: '2nd', type: 'cannedPercentage', value: '15', display: '15%' },
  { key: '3rd', type: 'cannedPercentage', value: '18', display: '18%' },
];
export const DEFAULT_DOLLAR_TIPS = [
  { key: '1st', type: 'cannedCurrency', value: '2.0', display: '$2' },
  { key: '2nd', type: 'cannedCurrency', value: '3.0', display: '$3' },
  { key: '3rd', type: 'cannedCurrency', value: '5.0', display: '$5' },
];

/**
 * @type {ShoppingCartState.State}
 */
const initState = {
  addressId: null,
  deliveryGroup: null,

  times: null,
  time: null,
  timeLoaded: false,

  serviceType: null,
  tips: null,
  tipDollarValue: null,
  tipDisplayValue: null,
  promoCode: '',
  isPromoCodeApplied: false,
  meals: [],
  mealNotes: {},

  order: null,
  isLoadingCheckout: false,
  checkoutSuccess: false,
  checkoutFailed: false,

  isPlacingOrder: false,

  note: '',

  cartErrors: {},

  /**
   * Container for UI State
   */
  ui: {
    tips: {
      inputType: DEFAULT_DOLLAR_TIPS[1].type,
      value: DEFAULT_DOLLAR_TIPS[1].value,
      options: [...DEFAULT_DOLLAR_TIPS],
    },
  },
};

const handleInitCart = (state, action) => {
  const cart = action.cartFromSession;
  const newShoppingCart = {
    meals: cart.meals,
    mealNotes: cart.mealNotes,
    addressId: cart.addressId,
    serviceType: cart.serviceType,
    deliveryGroup: cart.deliveryGroup,
    stop: cart.stop,
    shuttleDate: cart.shuttleDate,
  };
  return {
    ...state,
    ...newShoppingCart,
  };
};

const handleAddToCart = (state, action) => {
  const newShoppingCart = {
    meals: [...state.meals, action.meal],
    mealNotes: {
      ...state.mealNotes,
      [action.meal.id]: action.mealNote,
    },
    serviceType: action.serviceType,
    deliveryGroup: action.deliveryGroup,
    addressId: action.addressId,
  };
  setSessionItem({
    shoppingCart: newShoppingCart,
  });
  return {
    ...state,
    ...newShoppingCart,
  };
};

const handleUserCreateAddress = (state, action) => {
  const { addressId, meals } = state;
  if (!addressId && meals.length > 0) {
    const { id } = action.address;
    const newShoppingCart = {
      ...state,
      ...{
        addressId: id,
      },
    };
    setSessionItem({
      shoppingCart: newShoppingCart,
    });
    return newShoppingCart;
  }
  return state;
};

const handleUserUpdateAddress = (state, action) => {
  const { addressId, meals } = state;
  if (addressId && meals.length > 0) {
    const newShoppingCart = {
      ...state,
      ...{
        addressId: action.newAddressId,
      },
    };
    setSessionItem({
      shoppingCart: newShoppingCart,
    });
    return newShoppingCart;
  }
  return state;
};

const handleClearCart = () => {
  removeSessionItem(['shoppingCart']);
  return initState;
};

const handleChangeMeal = (state, action) => {
  const { index, meal } = action;
  const newMeals = state.meals
    .map((m, i) => {
      return i == index ? meal : m;
    })
    .filter((m) => !!m);
  if (newMeals.length === 0) {
    return handleClearCart(state, action);
  }
  const newShoppingCart = {
    ...state,
    ...{
      meals: newMeals,
    },
  };
  setSessionItem({
    shoppingCart: newShoppingCart,
  });
  return newShoppingCart;
};

const handleSetMealNote = (state, action) => {
  const newState = {
    ...state,
    mealNotes: {
      ...state.mealNotes,
      [action.mealId]: action.newNote,
    },
  };
  setSessionItem({
    shoppingCart: newState,
  });
  return newState;
};

const handleSetError = (state, action) => {
  const newState = {
    ...state,
    cartErrors: {
      ...state.cartErrors,
      [action.errorType]: {
        message: action.message,
        isLocal: action.isLocal,
      },
    },
  };
  return newState;
};

const handleRemoveError = (state, action) => {
  const newState = {
    ...state,
  };
  delete newState.cartErrors[action.errorType];
  return newState;
};

const shoppingCartReducer = (state = initState, action) => {
  switch (action.type) {
    case shoppingCartActionTypes.initCart:
      return handleInitCart(state, action);

    case shoppingCartActionTypes.addToCart:
      return handleAddToCart(state, action);

    case shoppingCartActionTypes.changeMeal:
      return handleChangeMeal(state, action);

    case shoppingCartActionTypes.clearCart:
      return handleClearCart();

    case shoppingCartActionTypes.getTimesStart:
      return {
        ...state,
        ...{
          times: null,
          time: null,
          timeLoaded: false,
        },
      };

    case shoppingCartActionTypes.getTimesSuccess:
      return {
        ...state,
        ...{
          times: action.times,
          time: action.times.length > 0 ? action.times[0] : null,
          timeLoaded: true,
        },
      };

    case shoppingCartActionTypes.setDeliveryTime:
      return {
        ...state,
        ...{
          time: action.time,
        },
      };

    case shoppingCartActionTypes.setDeliveryNote:
      return {
        ...state,
        ...{
          note: action.note,
        },
      };

    case shoppingCartActionTypes.checkoutOrderStart:
      return {
        ...state,
        ...{
          isLoadingCheckout: true,
          checkoutSuccess: false,
          checkoutFailed: false,
        },
      };

    case shoppingCartActionTypes.checkoutOrderSuccess:
      return {
        ...state,
        ...{
          order: action.payload.order,
          ui: {
            ...state.ui,
            tips: {
              inputType: action.payload.newTipType,
              value: action.payload.newTipValue,
              options: [...action.payload.newTipOptions],
            },
          },
          isLoadingCheckout: false,
          checkoutSuccess: true,
          checkoutFailed: false,
        },
      };

    case shoppingCartActionTypes.checkoutOrderFailed:
      return {
        ...state,
        ...{
          order: null,
          isLoadingCheckout: false,
          checkoutSuccess: false,
          checkoutFailed: true,
        },
      };

    case shoppingCartActionTypes.placeOrderStart:
      return {
        ...state,
        ...{
          isPlacingOrder: true,
        },
      };

    case shoppingCartActionTypes.placeOrderSuccess:
    case shoppingCartActionTypes.placeOrderFailed:
      return {
        ...state,
        ...{
          isPlacingOrder: false,
        },
      };

    case shoppingCartActionTypes.setPromocode:
      return {
        ...state,
        ...{
          promoCode: action.promoCode,
        },
      };

    case shoppingCartActionTypes.applyPromoCodeSuccess:
      return {
        ...state,
        ...{
          isPromoCodeApplied: true,
        },
      };

    case shoppingCartActionTypes.applyPromoCodeFailed:
      return {
        ...state,
        ...{
          isPromoCodeApplied: false,
          promoCode: '',
        },
      };

    case shoppingCartActionTypes.setTips:
      return {
        ...state,
        ...{
          tips: action.tipDollarValue,
          tipDollarValue: action.tipDollarValue,
          tipDisplayValue: action.tipDisplayValue,
        },
      };

    case shoppingCartActionTypes.tipsInputChange: {
      return {
        ...state,
        ui: {
          ...state.ui,
          tips: {
            inputType: action.payload.inputType,
            value: action.payload.value,
            options: action.payload.options,
          },
        },
      };
    }

    case shoppingCartActionTypes.setMealNote:
      return handleSetMealNote(state, action);

    case userActionTypes.persistNewUserAddress_success:
      return handleUserCreateAddress(state, action);

    case userActionTypes.updateUserAddressSuccess:
      return handleUserUpdateAddress(state, action);

    case shoppingCartActionTypes.setError:
      return handleSetError(state, action);

    case shoppingCartActionTypes.removeError:
      return handleRemoveError(state, action);

    case shoppingCartActionTypes.clearErrors:
      return {
        ...state,
        cartErrors: {},
      };

    case userActionTypes.logout:
      return handleClearCart();

    default:
      return state;
  }
};

export default shoppingCartReducer;
